import React, { Fragment } from 'react'
import { Loading } from '@myxplor/ui'
import moment from 'moment'

import RecordHeading from '../../../ui/record-heading'
import RecordDisplayList from '../../../ui/record-display-list'
import { RecordListActions, recordActionsToDisplay } from '../../../ui/gov-actions'

import { apiEndPoint } from '../helpers'
import { SessionBadges } from './badges'
import runSubmissionsForChild from '../run-submissions'
import forceSubmissionsForChild from '../force-submissions'
import { withdrawSessionReport } from '../withdraw-session-report'

const countWhereAbsentIs = (sessions, absentValue) =>
  sessions.reduce(
    (count, care) => (care.isChildAbsent === absentValue ? (count = count + 1) : count),
    0
  )

const actionsForRecord = ({ service_id, service_type, refresh_reports }) => ({ record }) => [
  withdrawSessionReport({ service_id, service_type, record, refresh_reports }),
]

export const formatSession = session => {
  const sessionOfCares = session.gov_record.SessionOfCares.results

  return {
    ...session,
    gov_record: {
      ...session.gov_record,
      sessionsAttended: countWhereAbsentIs(sessionOfCares, false).toString(),
      sessionsAbsent: countWhereAbsentIs(sessionOfCares, true).toString(),
      initialSubmittedDateTime: moment(session.gov_record.initialSubmittedDateTime).format(
        'YYYY-MM-DD'
      ),
      responseDueDate204C: session.gov_record.responseDueDate204C,
    },
  }
}

const TopContent = ({ record, service_id, service_type, refresh_session_reports, start_date }) => (
  <Fragment>
    <RecordListActions
      labelText="Submission Actions"
      options={[
        runSubmissionsForChild({
          record,
          service_id,
          service_type,
          refresh_session_reports,
          start_date,
        }),
        forceSubmissionsForChild({
          record,
          service_id,
          service_type,
          refresh_session_reports,
          start_date,
        }),
      ]}
    />
  </Fragment>
)

const DisplaySessionReports = ({
  service_id,
  service_type,
  session_reports,
  refresh_session_reports,
  start_date,
  record,
}) => {
  const formatSessions = (session_reports.data || []).map(s => formatSession(s))

  return (
    <RecordDisplayList
      records={formatSessions}
      recordBadgesComponent={SessionBadges}
      name="Submission"
      recordBase="gov_record"
      topContent={
        <TopContent
          {...{ record, service_id, service_type, refresh_session_reports, start_date }}
        />
      }
      showRaw
      level1={[
        {
          key: 'responseDueDate204C',
          label: 'Response Due 204C',
        },
        {
          key: 'sessionsAttended',
          label: 'Sessions Attended',
        },
        {
          key: 'sessionsAbsent',
          label: 'Sessions Absent',
        },
      ]}
      level2={[
        {
          key: 'initialSubmittedDateTime',
          label: 'Date Submitted',
        },
        {
          key: 'initialSubmittedDateTime',
          label: 'Last Submitted',
        },
      ]}
      actionButtonsComponent={recordActionsToDisplay({
        actionsForRecord: actionsForRecord({
          service_id,
          service_type,
          refresh_reports: () =>
            refresh_session_reports(apiEndPoint({ service_id, service_type, start_date, record })),
        }),
      })}
    />
  )
}

const SessionSummaryView = ({
  service_id,
  service_type,
  session_reports,
  record,
  start_date,
  refresh_session_reports,
}) => (
  <Fragment>
    <RecordHeading record={record.child} />
    {session_reports.loading ? (
      <Loading>Loading CCS Session Reports</Loading>
    ) : (
      <DisplaySessionReports
        service_id={service_id}
        service_type={service_type}
        session_reports={session_reports}
        record={record}
        start_date={start_date}
        refresh_session_reports={() =>
          refresh_session_reports(apiEndPoint({ service_id, service_type, start_date, record }))
        }
      />
    )}
  </Fragment>
)

export default SessionSummaryView



// WEBPACK FOOTER //
// ./src/session-summaries/details/views/index.jsx